import { UserManager, WebStorageStateStore, Log } from 'oidc-client-ap'
import Configuration from '@/configuration'

const BASE_URL = Configuration.value('externalAuthBaseUrl')

const settings = {
  authority: BASE_URL + '/.well-known/openid-configuration',
  client_id: Configuration.value('externalAuthClientId'),
  redirect_uri: `${window.location.origin}/signin.html`,
  response_type: 'id_token token',
  scope: 'openid',
  post_logout_redirect_uri: 'https://www.airproducts.com',
  automaticSilentRenew: false,
  silent_redirect_uri: `${window.location.origin}/signin-silent.html`
}

localStorage.setItem('user_manager_external', JSON.stringify(settings))
settings.userStore = new WebStorageStateStore({ store: window.localStorage })
const userManager = new UserManager(settings)

export default {
  getUser() {
    return userManager.getUser()
  },
  async getLoggedIn() {
    const user = await userManager.getUser()
    return user && !user.expired
  },
  login() {
    return userManager.signinRedirect()
  },
  logout() {
    return userManager.signoutRedirect()
  },
  signinSilentCallback() {
    return userManager.signinSilentCallback()
  }
}
